var map = {
	"./Spin_General_001.webp": 67440,
	"./Spin_General_002.webp": 91623,
	"./Spin_General_003.webp": 58059,
	"./Spin_General_004.webp": 39150,
	"./Spin_General_005.webp": 17970,
	"./Spin_General_006.webp": 12256,
	"./Spin_General_007.webp": 81752,
	"./Spin_General_008.webp": 34013,
	"./Spin_General_009.webp": 46031,
	"./Spin_General_010.webp": 32062,
	"./Spin_General_011.webp": 15588,
	"./Spin_General_012.webp": 45779,
	"./Spin_General_013.webp": 45576,
	"./Spin_General_014.webp": 44032,
	"./Spin_General_015.webp": 5973,
	"./Spin_General_016.webp": 69842,
	"./Spin_General_017.webp": 35576,
	"./Spin_General_018.webp": 76269,
	"./Spin_General_019.webp": 59181,
	"./Spin_General_020.webp": 47246,
	"./Spin_General_021.webp": 90800,
	"./Spin_General_022.webp": 85778,
	"./Spin_General_023.webp": 65659,
	"./Spin_General_024.webp": 61578,
	"./Spin_General_025.webp": 72529,
	"./Spin_General_026.webp": 28665,
	"./Spin_General_027.webp": 75018,
	"./Spin_General_028.webp": 78620,
	"./Spin_General_029.webp": 52746,
	"./Spin_General_030.webp": 35979,
	"./Spin_General_031.webp": 44337,
	"./Spin_General_032.webp": 1259,
	"./Spin_General_033.webp": 29540,
	"./Spin_General_034.webp": 93181,
	"./Spin_General_035.webp": 55469,
	"./Spin_General_036.webp": 59096,
	"./Spin_General_037.webp": 54101,
	"./Spin_General_038.webp": 18386,
	"./Spin_General_039.webp": 61544,
	"./Spin_General_040.webp": 56234,
	"./Spin_General_041.webp": 86031,
	"./Spin_General_042.webp": 66402,
	"./Spin_General_043.webp": 61494,
	"./Spin_General_044.webp": 38849,
	"./Spin_General_045.webp": 21717,
	"./Spin_General_046.webp": 58203,
	"./Spin_General_047.webp": 64622,
	"./Spin_General_048.webp": 58488,
	"./Spin_General_049.webp": 96794,
	"./Spin_General_050.webp": 83538,
	"./Spin_General_051.webp": 22767,
	"./Spin_General_052.webp": 46304,
	"./Spin_General_053.webp": 9648,
	"./Spin_General_054.webp": 70789,
	"./Spin_General_055.webp": 8865,
	"./Spin_General_056.webp": 92157,
	"./Spin_General_057.webp": 52429,
	"./Spin_General_058.webp": 69974,
	"./Spin_General_059.webp": 70954,
	"./Spin_General_060.webp": 8151,
	"./Spin_General_061.webp": 86426,
	"./Spin_General_062.webp": 34532,
	"./Spin_General_063.webp": 99920,
	"./Spin_General_064.webp": 350,
	"./Spin_General_065.webp": 42257,
	"./Spin_General_066.webp": 32026,
	"./Spin_General_067.webp": 71577,
	"./Spin_General_068.webp": 1722,
	"./Spin_General_069.webp": 57968,
	"./Spin_General_070.webp": 90184,
	"./Spin_General_071.webp": 68194,
	"./Spin_General_072.webp": 90994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86132;